import { render, staticRenderFns } from "./pcb.vue?vue&type=template&id=349314ea&scoped=true"
import script from "./pcb.vue?vue&type=script&lang=js"
export * from "./pcb.vue?vue&type=script&lang=js"
import style0 from "./pcb.vue?vue&type=style&index=0&id=349314ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349314ea",
  null
  
)

export default component.exports